import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import TopSection from '../../../LT/TopSection';
import { fetchAutoTargetReviewData } from '../../../../redux/actions/ContractMaintenance/GetAutoTargetReview';
import { Loader } from '../../../../components/common/Loader';
import DataDetails from './DataDetails';
import ButtonComponent from '../../../../components/common/button/Button';
import { setSelectedItem } from '../../../../redux/actions/SupportTicket/selectionSlice';
import { getAutoTargetReviewEndpoint } from '../../../../common/endpoints';
import { postApproveAutoTargetReview } from '../../../../redux/actions/ContractMaintenance/ApproveAutoTarget';
import { postRejectAutoTargetReview } from '../../../../redux/actions/ContractMaintenance/RejectAutoTarget';
import Modal from '../../../../components/common/modal/Modal';

const AutoTargetValue = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [getAutoTargetData, setAutoTargetData] = useState([]);
  const [isRejectBtnDisable, setIsRejectBtnDisable] = useState(true);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);

  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const userRole = localStorage.getItem("CDRole");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const computeRejectButtonDisabled = (selectedRows) => {
    return selectedRows.some((row) =>
      row.status?.toLowerCase() === "rejected" &&
      (!row.reasonIfRejected || row.reasonIfRejected.toString().trim() === "")
    );
  };

  const showRejectReasonToast = (selectedRows) => {
    if (computeRejectButtonDisabled(selectedRows)) {
      toast.warn("Reject reason is mandatory for selected rejected rows for enabling Reject button.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleCellValueChange = (params) => {
    if (rowsData.some(row => row.alSeqId === params.data.alSeqId)) {
      const updatedSelectedRows = rowsData.map(row =>
        row.alSeqId === params.data.alSeqId ? params.data : row
      );
      setRowsData(updatedSelectedRows);
      setIsRejectBtnDisable(computeRejectButtonDisabled(updatedSelectedRows));
      showRejectReasonToast(updatedSelectedRows);
    }
  }

  const onSelectionChanged = (params) => {
    const selectedRowsOnCurrentPage = [];
    const currentPage = params.api.paginationGetCurrentPage();
    const pageSize = params.api.paginationGetPageSize();
    let index = 0;

    params.api.forEachNodeAfterFilterAndSort((node) => {
      const nodePage = Math.floor(index / pageSize);
      if (nodePage === currentPage && node.isSelected()) {
        selectedRowsOnCurrentPage.push(node.data);
      }
      index++;
    });

    setRowsData(selectedRowsOnCurrentPage);
    dispatch(setSelectedItem(selectedRowsOnCurrentPage));
    setIsRejectBtnDisable(computeRejectButtonDisabled(selectedRowsOnCurrentPage));
    showRejectReasonToast(selectedRowsOnCurrentPage);
  };

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) => {
        const status = rowNode.data.status.toLowerCase();
        return status.includes("approved") ||
        userRole === "Viewer" ?
        false : 
        true
      }
    };
  }, []);

  const getRowStyle = (params) => {
    const status = params.data.status.toLowerCase();
    if (
      status.includes("approved") 
    ) {
      return { backgroundColor: "#aaaaaa" };
    }
    return null;
  };

  const approveHandler = async () => {
    setOpenApproveModal(false)
    setIsLoading(true);
    try {
      const response = await dispatch(postApproveAutoTargetReview({
        dynamicEndpoint: `${getAutoTargetReviewEndpoint}/approve?userName=${cleanUsername(userName)}&userEmail=${userEmail}`,
        data: rowsData,
      }));
      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Target values has been approved successfully.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsLoading(false);
        setIsRejectBtnDisable(true);
        setRowsData([]);
        getAutoTargetReviewData();
      } else {
        setIsLoading(false);
        toast.error("something went wrong, please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsRejectBtnDisable(true);
        setRowsData([]);
      }
    } catch (error) {
      console.log("API error:", error);
      setIsLoading(false);
        toast.error("something went wrong, please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsRejectBtnDisable(true);
        setRowsData([]);
    }
  }

  const rejectHandler = async () => {
    setOpenRejectModal(false)
    setIsLoading(true);
    try {
      const response = await dispatch(postRejectAutoTargetReview({
        dynamicEndpoint: `${getAutoTargetReviewEndpoint}/reject?userName=${cleanUsername(userName)}&userEmail=${userEmail}`,
        data: rowsData,
      }));
      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Target values has been Rejected successfully.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsLoading(false);
        setIsRejectBtnDisable(true);
        setRowsData([]);
        getAutoTargetReviewData();
      } else {
        setIsLoading(false);
        toast.error("something went wrong, please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsRejectBtnDisable(true);
        setRowsData([]);
      }
    } catch (error) {
      console.log("API error:", error);
      setIsLoading(false);
        toast.error("something went wrong, please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
        setIsRejectBtnDisable(true);
        setRowsData([]);
    }
  }

  const getAutoTargetReviewData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(fetchAutoTargetReviewData());
      if (response.meta.requestStatus === "fulfilled") {
        setAutoTargetData(response.payload);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        console.log(
          "Failed to fetch data:",
          response.payload.responseMessage
        );
      }
    } catch (error) {
      console.log("API error:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    getAutoTargetReviewData();
  }, [getAutoTargetReviewData])

  return (
    <>
      <TopSection
          labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Contract Maintenance", path: "/contract-maintenance" },
          { title: "Review Auto Target Value" },
          ]}
          hideHeader={true}
          headerName={"Review Auto Target Value"}
      />
      <div className="priceMemo_dataTable">
        {isLoading ? (
          <Loader />
        )
        :
        <>
          <DataDetails
            rowData={getAutoTargetData}
            onSelectionChanged={onSelectionChanged}
            rowSelection={rowSelection}
            handleCellValueChange={handleCellValueChange}
            getRowStyle={getRowStyle}
            userRole={userRole}
          />
          </>
        }
          { userRole !== "Viewer" && (
          <div
            style={{
              marginTop: "15px",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "170px",
              }}
            >
              <ButtonComponent
                label="Approve"
                bgColor="#000"
                color="#fff"
                disabled={rowsData.length === 0}
                onClick={() => setOpenApproveModal(true)}
              />
              <ButtonComponent
                label="Reject"
                bgColor="#000"
                color="#fff"
                onClick={() => setOpenRejectModal(true)}
                disabled={rowsData.length === 0 || isRejectBtnDisable}
              />
            </div>
          </div>
          )}
        </div>
        { openRejectModal &&
          <Modal
            open={openRejectModal}
            handleClose={() => setOpenRejectModal(false)}
            title="Reject Target Values"
            content={
              <div>
                <p>{rowsData?.length > 1 ? `Are you sure you want to reject these Target Values?` : `Are you sure you want to reject this Target Value?`}</p>
              </div>
            }
            action={
              <>
              <ButtonComponent
                maxWidth="170px"
                label="No"
                bgColor="white"
                color="black"
                onClick={() => setOpenRejectModal(false)}
              />
              <ButtonComponent
                maxWidth="170px"
                label="Yes"
                bgColor="black"
                color="white"
                onClick={rejectHandler}
              />
              </>
            }
          />}
          { openApproveModal &&
          <Modal
            open={openApproveModal}
            handleClose={() => setOpenApproveModal(false)}
            title="Approve Target Values"
            content={
              <div>
                <p>{rowsData?.length > 1 ? `Are you sure you want to approve these Target Values?` : `Are you sure you want to approve this Target Value?`}</p>
              </div>
            }
            action={
              <>
              <ButtonComponent
                maxWidth="170px"
                label="No"
                bgColor="white"
                color="black"
                onClick={() => setOpenApproveModal(false)}
              />
              <ButtonComponent
                maxWidth="170px"
                label="Yes"
                bgColor="black"
                color="white"
                onClick={approveHandler}
              />
              </>
            }
          />}
    </>
  )
}

export default AutoTargetValue;